/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const AlertReportedFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.92 4.57849C11.4166 3.80717 12.5834 3.80717 13.08 4.57849L21.8078 18.1358C22.3316 18.9494 21.723 20 20.7278 20H3.27216C2.27699 20 1.66839 18.9494 2.1922 18.1358L10.92 4.57849ZM11 12.5V8.5C11 7.94772 11.4477 7.5 12 7.5C12.5523 7.5 13 7.94772 13 8.5V12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5ZM12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z'
      fill='currentColor'
    />
  </React.Fragment>
)
